export default __webpack_public_path__ + "static/media/PIFA.10ace873.png";